/**
 * статы честь и здравомыслие
 * статы для АСИ
 * черта с 1го уровня для всех
 * валидация численных параметров
 */
class Maker {
    static row(...cells) {
        let tr = $('<div class="ro">');
        cells.forEach(cell => tr.append($('<div class="co">').html('<span>' + cell + '</span>')));
        return $('<div>').append(tr).html();
    }

    static box(b1, b2) {
        return $('<div>')
            .append($('<div class="settings__label">').html(b1))
            .append(b2)
            .html();
    }

    static flex(style = {}, data = []) {
        let div = $('<div class="grid-4_sm-2">');
        for (const item of data) {
            div.append($(`<div class="calc_settings_stat_cost_tuner col">`).html(item));
        }
        return div;
    }

    static checkbox(name, value) {
        value = Number(value);
        let checked = value ? 'checked' : '';
        return `<span class="form__checkbox"><input type="checkbox" name="${name}" value="1" ${checked} onclick="PointBuyCalc.settingsSave(this)"><span class="checkbox__button"></span></div>`;
    }

    static tuner(name, value) {
        let html = '';
        html += `<span class="calc_stat_button btn btn-contrast" onclick="PointBuyCalc.settingsSave('${name}', ${value - 1});">-</span>`;
        html += `<span class="calc_stat_input">${value}</span>`;
        html += `<span class="calc_stat_button btn btn-contrast" onclick="PointBuyCalc.settingsSave('${name}', ${value + 1});">+</span>`;
        html = `<div class="settings__value">${html}</div>`;
        return html;
    }

    static button(caption, callback, cls = 'cbutton', target = '') {
        let btn = $(`<span class="${cls} col btn" data-target="${target}">`);
        btn.html('<span>' + caption + '</span>');
        btn.click(callback);
        return btn;
    }

    static select(name, callback, cls = 'cbutton', target = '') {
        let btn = $(`<span class="${cls} col btn" data-target="${target}">`);
        btn.html('<span>' + caption + '</span>');
        btn.click(callback);
        return btn;
    }

    static raceTile(race, click) {
        return `<div class="col tile calc_tile">`
            + `<a class="tile-wrapper contrast race" onclick="${click}">`
            + `<span class="tile__icon sprite-race__${race.classes}"></span>`
            + `<span class="article_title">${race.rname}</span>`
            + `<span class="article_title_en">${race.ename}</span>`
            + `<span class="article_source">${race.source}</span></a></div>`;
    }
}

class Allocable {
    static item = null;

    static allocator() {
        return $('#stat_allocate');
    }

    static make(stat, idx, item) {
        let caption = tr(('ALL' === item.pstat) ? 'ALL' : stat);
        let html = `<span class="allocable_button" onclick="Allocable.show(this);" data-stat="${stat}" data-index="${idx}">${caption}</span>`;
        return html;
    }

    static show(item) {
        if (Allocable.allocator().hasClass('active')) {
            Allocable.hide();
            if (Allocable.item === $(item)) {
                return;
            }
        }

        Allocable.item = $(item);
        let allocStat = Allocable.item.attr('data-stat');
        if (!PointBuyCalc.settings.relocateEnabled && 'ANY' !== allocStat && 'FEAT' !== allocStat) {
            return;
        }
        if ('ALL' === allocStat) {
            return;
        }

        $('.allocable_button').removeClass('active');
        Allocable.item.addClass('active');

        let picker = '';
        for (const stat of PointBuyCalc.getStats()) {
            let active = (stat === allocStat) ? ' active' : '';
            picker += `<span class="allocable_pick${active}" onclick="Allocable.pick('${stat}');" data-stat="${stat}">${tr(stat)}</span>`;
        }

        if (PointBuyCalc.isAllocFeat(Allocable.item.attr('data-index'))) {
            let active = ('FEAT' === allocStat) ? ' active' : '';
            picker += `<span class="allocable_pick${active}" onclick="Allocable.pick('NO');" data-stat="NO">${tr('NO')}</span>`;
        }

        Allocable.allocator()
            .css({
                'top': item.offsetTop + item.offsetHeight + 4 + 'px',
                'left': item.offsetLeft + item.offsetWidth / 2 + 'px'
            })
            .addClass('active')
            .html(picker);
    }

    static pick(stat) {
        PointBuyCalc.setAllocable(Allocable.item.attr('data-index'), stat);
        Allocable.hide();
    }

    static hide() {
        $('#stat_allocate').removeClass('active').html('');
        $('.allocable_button').removeClass('active');
    }

    static onGlobalClick(event) {
        if (!$('#stat_allocate').is(':visible')) {
            return;
        }

        let target = $(event.target);
        if (target.hasClass('allocable_button')) {
            // console.debug('start');
            return;
        }
        if (target.hasClass('allocable_pick')) {
            // console.debug('pick');
            return;
        }
        if ('stat_allocate' === target.attr('id')) {
            // console.debug('frame');
            return;
        }

        //click outside
        Allocable.hide();
    }
}

function tr(code) {
    const trans = {
        _lang: 'ru', data: {
            'STR': {ru: 'Сила',},
            'DEX': {ru: 'Ловкость',},
            'CON': {ru: 'Телосложение',},
            'INT': {ru: 'Интеллект',},
            'WIS': {ru: 'Мудрость',},
            'CHA': {ru: 'Харизма',},
            'HON': {ru: 'Честь',},
            'SAN': {ru: 'Здравомыслие',},
            'NO': {ru: 'нет',},
            'FEAT': {ru: 'черта',},
            'ALL': {ru: 'всем',},
            'ANY': {ru: 'любой',},
            'settings_relocateEnabled': {ru: 'Разрешено переназначение бонусов (TCE, 7)',},
            'settings_coloredStats': {ru: 'Расцвечивать прогрессию',},
            'settings_statBase': {ru: 'Минимум покупки',},
            'settings_statMax': {ru: 'Максимум покупки',},
            'settings_statCosts': {ru: 'Стоимость покупок',},
            'settings_maxBudget': {ru: 'Бюджет покупки',},
            'settings_honorEnabled': {ru: 'Включить Честь',},
            'settings_honorSurplus': {ru: 'Бюджет на Честь',},
            'settings_sanityEnabled': {ru: 'Включить Здравомыслие',},
            'settings_sanitySurplus': {ru: 'Бюджет на Здравомыслие',},
            'settings_enabledASI': {ru: 'Увеличения Характеристик',},
            //'': { ru : '', },
        }
    };
    return trans.data[code] && trans.data[code][trans._lang] || `?${code}?`;
}

class PointBuyCalc {

    // static stats = ['STR', 'DEX', 'CON', 'INT', 'WIS', 'CHA'];
    static stats = ['STR', 'DEX', 'CON', 'INT', 'WIS', 'CHA', 'HON', 'SAN'];

    static mode = 'point-buy';
    static withTunes = false;
    static withRolls = false;
    static standardArray = false;
    static data = {};
    static settings = {};
    static status = {};
    static settingsStorageKey = 'pointBuyCalcSettings';


    static getStats() {
        let stats = ['STR', 'DEX', 'CON', 'INT', 'WIS', 'CHA'];

        if (this.settings.honorEnabled) {
            stats.push('HON');
        }

        if (this.settings.sanityEnabled) {
            stats.push('SAN');
        }

        return stats;
    }


    static settingsLoad(reset) {
        this.settings = {};
        let settingsDefault = {
            relocateEnabled: 1,
            maxBudget: 27,
            statBase: 8,
            statMax: 15,
            coloredStats: 0,
            //      0  1  2   3   4   5   6   7   8   9  10  11  12  13  14  15  16  17  18
            cost: [0, 0, 0, -9, -6, -4, -2, -1, 0, 1, 2, 3, 4, 5, 7, 9, 12, 15, 19],
            honorEnabled: false,
            honorSurplus: 3,
            sanityEnabled: false,
            sanitySurplus: 3,
            enabledASI: false,
        };

        for (const key of Object.keys(settingsDefault)) {
            this.settings[key] = settingsDefault[key];
        }

        if (!reset) {
            let settingsStored = JSON.parse(localStorage.getItem(this.settingsStorageKey) || '{}');
            for (const key of Object.keys(settingsStored)) {
                this.settings[key] = settingsStored[key];
            }
        }
    }

    static settingsSave(key, value) {
        if (key) {
            if (key !== String(key)) {
                let input = $(key);
                key = input.attr('name');
                value = Number(input.prop('checked'));
            }

            let keys = key.split('/');
            if (keys[1]) {
                this.settings[keys[0]][parseInt(keys[1])] = parseInt(value);
            } else {
                this.settings[keys[0]] = parseInt(value);
            }
        }

        localStorage.setItem(this.settingsStorageKey, JSON.stringify(this.settings || {}));

        if (!this.settings.relocateEnabled) {
            this.status.race.alloc1 = '';
            this.status.race.alloc2 = '';
            this.status.race.alloc3 = '';
            this.updateHash();
            this.updateSubrace();
        }

        this.updateStats();
        this.updateSettings();
    }

    static updateSettings() {
        let page = $('.calc_page_settings');

        page.html('');
        let table = $('<div class="calc_page_settings__table">');
        table.append(
            Maker.row(
                tr('settings_relocateEnabled'),
                Maker.checkbox('relocateEnabled', PointBuyCalc.settings.relocateEnabled)));
        table.append(
            Maker.row(
                tr('settings_coloredStats'),
                Maker.checkbox('coloredStats', PointBuyCalc.settings.coloredStats)));
        table.append(
            Maker.row(
                tr('settings_statBase'),
                Maker.tuner('statBase', PointBuyCalc.settings.statBase)));
        table.append(
            Maker.row(
                tr('settings_statMax'),
                Maker.tuner('statMax', PointBuyCalc.settings.statMax)));
        table.append(
            Maker.row(
                tr('settings_maxBudget'),
                Maker.tuner('maxBudget', PointBuyCalc.settings.maxBudget)));
        table.append(
            Maker.row(
                tr('settings_honorEnabled'),
                Maker.checkbox('honorEnabled', PointBuyCalc.settings.honorEnabled)));
        table.append(
            Maker.row(
                tr('settings_honorSurplus'),
                Maker.tuner('honorSurplus', PointBuyCalc.settings.honorSurplus)));
        table.append(
            Maker.row(
                tr('settings_sanityEnabled'),
                Maker.checkbox('sanityEnabled', PointBuyCalc.settings.sanityEnabled)));
        table.append(
            Maker.row(
                tr('settings_sanitySurplus'),
                Maker.tuner('sanitySurplus', PointBuyCalc.settings.sanitySurplus)));
        table.append(
            Maker.row(
                tr('settings_enabledASI'),
                Maker.checkbox('enabledASI', PointBuyCalc.settings.enabledASI)));
        page.append(table);

        let tuners = [];
        for (let i = 18; i > 2; i--) {
            tuners.push(
                Maker.box(
                    i,
                    Maker.tuner(`cost/${i}`, PointBuyCalc.settings.cost[i])));
        }
        page.append($('<div class="settings__table">').html(Maker.box(tr('settings_statCosts'), Maker.flex({width: 25}, tuners))));

        $('.calc_settings_stat_cost_tuner').each(
            (i, tuner) => {
                let value = Number($(tuner).children().first().html());
                let isActive = (this.settings.statBase <= value && value <= this.settings.statMax);
                $(tuner).removeClass('active inactive').addClass(isActive ? 'active' : 'inactive');
            }
        );

        page.append($('<div class="calc_reset">').html(Maker.button('Сброс настроек', () => PointBuyCalc.resetSettings(), 'btn-mint')));
    }

    static resetSettings() {
        this.settingsLoad(true);
        this.settingsSave();
    }

    static #modeIcon(mode, def) {
        let roll = Math.round(Math.random() * 100);
        let svg = 1 === roll ? 'rickroll' : 2 === roll ? 'finik' : def;
        return drawIcon(svg, 16, true);
    }

    static #initPager() {
        const raceButton = Maker.button('Раса', () => PointBuyCalc.selectPage('race'), 'cbutton page_button', 'race');
        const statsButton = Maker.button('Расчёт', () => PointBuyCalc.selectPage('stats'), 'cbutton page_button', 'stats');
        const settingsButton = Maker.button('Настройки', () => PointBuyCalc.selectPage('settings'), 'cbutton page_button', 'settings');
        const modeBuyButton = Maker.button(
                                    this.#modeIcon('point-buy', 'coins'),
                                    () => PointBuyCalc.changeMode('point-buy'),
                                    'method_button', 'point-buy');
        const modeRollButton = Maker.button(
                                    this.#modeIcon('roll', '2d6'),
                                    () => PointBuyCalc.changeMode('roll'),
                                    'method_button', 'roll');
        const modeStdButton = Maker.button(
                                    this.#modeIcon('standard', 'stats'),
                                    () => PointBuyCalc.changeMode('standard'),
                                    'method_button', 'standard');

        $('div.calc_pager')
            .append(raceButton)
            .append(
                $('<span class="col btn">')
                    .append(modeBuyButton)
                    .append(modeRollButton)
                    .append(modeStdButton)
            )
            .append(statsButton)
            .append(settingsButton);
    }

    static #initRaceList() {
        let races_html = '';
        for (const race of Object.values(PointBuyCalc.data.races)) {
            races_html += Maker.raceTile(race, `PointBuyCalc.setRace('${race.key}')`);
        }
        $('div#race_holder').html(races_html);
    }

    static init() {
        if (document.querySelectorAll("textarea.editor").length > 0) {
            return;
        }

        PointBuyCalc.settingsLoad();
        PointBuyCalc.status = {
            page: '',
            race: {name: '', subrace: '', alloc1: '', alloc2: '', alloc3: ''},
            stats: {STR: 0, DEX: 0, CON: 0, WIS: 0, INT: 0, CHA: 0, HON: 0, SAN: 0,},
        };

        PointBuyCalc.#initPager();
        PointBuyCalc.#initRaceList();
        PointBuyCalc.updateSettings();

        PointBuyCalc.changeMode('point-buy');

        PointBuyCalc.loadHash(window.location.hash);
        PointBuyCalc.selectPage(PointBuyCalc.status.race.name ? 'stats' : 'race');

        document.body.addEventListener('click', Allocable.onGlobalClick);
    }

    static totalBudget() {
        let budget = this.settings.maxBudget
            + (this.settings.honorEnabled ? this.settings.honorSurplus : 0)
            + (this.settings.sanityEnabled ? this.settings.sanitySurplus : 0);

        return budget;
    }

    static totalCost(modStat, modDelta) {
        let cost = 0;
        for (const stat of this.getStats()) {
            let val = this.settings.statBase + this.status.stats[stat] + ((modStat === stat) ? modDelta : 0);
            cost += this.settings.cost[val];
        }
        return cost;
    }

    static tune(stat, delta) {
        if (!this.withTunes) {
            const statRef = this.getStats();
            const target = (statRef.indexOf(stat) + delta) % statRef.length;
            const targetStat = statRef[target];

            const swap = this.status.stats[stat];
            this.status.stats[stat] = this.status.stats[targetStat];
            this.status.stats[targetStat] = swap;

            this.updateStats();
            this.updateHash();

            return;
        }

        delta = parseInt(delta);
        let oldValue = this.settings.statBase + this.status.stats[stat];
        let newValue = oldValue + delta;
        if (delta < 0 && newValue < this.settings.statBase) {
            return;
        }
        if (delta > 0 && newValue > this.settings.statMax) {
            return;
        }

        if (delta > 0 && this.totalCost(stat, delta) > this.totalBudget()) {
            return;
        }

        this.status.stats[stat] += delta;
        this.updateStats();
        this.updateHash();
    }

    static selectPage(page) {
        if (page === 'stats' && !this.status.race.name) {
            return;
        }

        $('div.calc_page').hide();
        $(`div.calc_page_${page}`).show();
        $('span.page_button').removeClass('btn-green').addClass('btn-gray');
        $(`span.page_button[data-target=${page}]`).removeClass('btn-gray').addClass('btn-green');
        $(`span.page_button[data-target=stats]`).get(0).classList.toggle('btn-blocked', !this.status.race.name)

        this.status.page = page;
        window.scrollTo(0, 0);
    }

    static setRace(race) {
        if (this.status.race.name !== race) {
            this.status.race.name = race;
            this.status.race.subrace = '';
            this.status.race.alloc1 = '';
            this.status.race.alloc2 = '';
            this.status.race.alloc3 = '';
            this.#fixDoubles();
            this.updateHash();
            this.updateRace();
            for (const subrace of Object.values(this.data.races[race].subraces || [])) {
                this.setSubrace(subrace.key);
                break;
            }
            this.updateSubrace();
            this.updateStats();
        }
        if (this.status.page === 'race') {
            this.selectPage('stats');
        }
        //console.table(this.status);
    }

    static updateRace(race) {
        race = race || this.data.races[this.status.race.name];
        let selectedRaceTile = $('.calc_page_stats_race');
        selectedRaceTile.find('.article_title').html(race.rname);
        selectedRaceTile.find('.article_title_en').html(`${race.ename}`);
        selectedRaceTile.find('.article_source').html(race.source);
        selectedRaceTile.find('.tile__icon').removeClass().addClass(`tile__icon ${race.classes}`);
        selectedRaceTile.find('a').removeClass().addClass(`tile-wrapper contrast race active`);

        let subraceHolder = $('.calc_page_stats_subrace_list');
        subraceHolder.html('');
        Allocable.hide();

        if (!race.subraces) {
            subraceHolder.hide();
            return;
        }

        subraceHolder.show();
        for (const subrace of Object.values(race.subraces)) {
            let caption = subrace.rname + (subrace.source ? ` (${subrace.source})` : '');
            subraceHolder.append(Maker.button(caption, () => PointBuyCalc.setSubrace(subrace.key), 'fbutton subrace_button btn-sm', subrace.key));
        }
    }

    static #fixDoubles() {
        let used = {};
        // console.log(this.getAllocable());
        this.getAllocable().forEach((allocated, index) => {
            // console.log(allocated.stat);
            if (!allocated || !allocated.stat || 'ANY' === allocated.stat || 'FEAT' === allocated.pstat) {
                return;
            }

            if (used[allocated.stat]) {
                // console.log(this.getStats());
                let otherStat = this.getStats().filter(stat => !used[stat]).shift();
                this.setAllocable(index + 1, otherStat)
                used[otherStat] = true;
                return;
            }

            used[allocated.stat] = true;
        });
    }

    static setSubrace(subrace) {
        this.status.race.subrace = subrace;
        for (let i = 1; i <= 3; ++i) {
            if (i > (this.data.races[this.status.race.name].stats || []).length) {
                this.status.race[`alloc${i}`] = '';
            }
        }

        this.#fixDoubles();
        this.updateHash();
        this.updateSubrace();
        this.updateStats();
        Allocable.hide();
    }

    static updateSubrace() {
        $('span.subrace_button').removeClass('btn-green').addClass('btn-gray');
        if (this.status.race.subrace) {
            $(`span.subrace_button[data-target=${this.status.race.subrace}]`).removeClass('btn-gray').addClass('btn-green');
        }

        this.updateAllocable();
    }

    static isAllocFeat(alloc) {
        if ('object' !== typeof (alloc)) {
            alloc = this.getAllocable()[parseInt(alloc) - 1];
        }
        //console.log(alloc);
        return alloc && ('FEAT' === alloc.stat || 'FEAT' === alloc.pstat);
    }

    static getAllocable() {
        let alloc = [], idx = 0;
        let race = this.data.races[this.status.race.name];
        if (this.status.race.name && race.stats) {
            for (const stat of race.stats) {
                Object.assign(alloc[idx++] = {}, stat);
            }
        }
        if (this.status.race.subrace) {
            for (const stat of race.subraces[this.status.race.subrace].stats) {
                Object.assign(alloc[idx++] = {}, stat);
            }
        }
        for (const i in alloc) {
            let allokey = 'alloc' + (parseInt(i) + 1);
            if (this.status.race[allokey]) {
                alloc[i].pstat = alloc[i].stat;
                alloc[i].stat = this.status.race[allokey];
            }
        }
        return alloc;
    }

    static updateAllocable() {
        let alloc = this.getAllocable();
        let html = '', idx = 0;
        for (const item of alloc) {
            if (idx++) {
                html += ', ';
            }
            if (this.isAllocFeat(item)) {
                html += 'Черта: ';
            }
            html += ` <span class="bonus_stat">+${item.bonus} к ` + Allocable.make(item.stat, idx, item) + '</span>';
        }
        html = html ? (`Характеристики: ${html}`) : '<b>Выберите подрасу</b>';
        $('.calc_page_stats_race_bonus').html(html);
    }

    static setAllocable(index, stat) {
        // console.log(index, stat);
        if (!this.isAllocFeat(index)) {
            let alloc = this.getAllocable();
            let oldStat = alloc[index - 1]?.stat || '';
            for (let i = 1; i < 4; ++i) {
                if (index !== i && alloc[i - 1] && (alloc[i - 1].stat === stat) && !this.isAllocFeat(i)) {
                    this.status.race[`alloc${i}`] = oldStat;
                }
            }
        }
        this.status.race[`alloc${index}`] = (stat === 'NO' && this.isAllocFeat(index)) ? '' : stat;
        this.updateAllocable();
        this.updateStats();
        this.updateHash();
    };

    static resetStats() {
        for (let stat of this.stats) {
            this.status.stats[stat] = 0;
        }
        this.updateHash();
        this.updateStats();
    }

    static updateStats() {
        let stats = {};
        for (const stat of Object.values(this.stats)) {
            stats[stat] = this.withTunes ? this.settings.statBase : 0;
            stats[stat] += this.status.stats[stat];
            $(`#calc_${stat}_base`).html(stats[stat]);
            $(`#calc_${stat}_cost`).html(this.settings.cost[stats[stat]]);
            $(`#calc_${stat}_race`).html('0');
            $(`#calc_${stat}_feat`).html('0');
        }

        let main = document.querySelector('#calc_main');
        main.classList.toggle('honor_enabled', this.settings.honorEnabled);
        main.classList.toggle('sanity_enabled', this.settings.sanityEnabled);

        let alloc = this.getAllocable();
        for (const i in alloc) {
            for (const stat of Object.keys(stats)) {
                if (stat === alloc[i].stat || 'ALL' === alloc[i].stat || 'ALL' === alloc[i].pstat) {
                    stats[stat] += alloc[i].bonus;
                    if (this.isAllocFeat(parseInt(i) + 1)) {
                        $(`#calc_${stat}_feat`).html(Utils.signedNumber(alloc[i].bonus, true));
                    } else {
                        $(`#calc_${stat}_race`).html(Utils.signedNumber(alloc[i].bonus, true));
                    }
                }
            }
        }

        let rarity = {'-4': 'incapable', '-3': 'broken', '-2': 'frail', '-1': 'poor', 0: 'common', 1: 'uncommon', 2: 'rare', 3: 'very_rare', 4: 'epic', 5:'legendary'};
        for (const stat of Object.keys(stats)) {
            let mod = Math.floor((stats[stat] - 10) / 2);
            let rare = (rarity[mod] && this.settings.coloredStats) ? `stat_value_${rarity[mod]}` : 'stat_value_bold';
            $(`#calc_${stat}_total`).removeClass().addClass(rare).html(stats[stat]);
            $(`#calc_${stat}_mod`).removeClass().addClass(rare).html(Utils.signedNumber(mod, true));
        }

        $('#calc_cost_current').html(this.totalCost());
        $('#calc_cost_max').html(this.totalBudget());
    }

    static updateHash() {
        // return;
        // let data = {
        //     race:    this.status.race.name,
        //     subrace: this.status.race.subrace,
        //     alloc1:  this.status.race.alloc1,
        //     alloc2:  this.status.race.alloc2,
        //     alloc3:  this.status.race.alloc3,
        //     stats: [
        //              this.status.stats.STR,
        //              this.status.stats.DEX,
        //              this.status.stats.CON,
        //              this.status.stats.INT,
        //              this.status.stats.WIS,
        //              this.status.stats.CHA,
        //              this.status.stats.HON,
        //              this.status.stats.SAN
        //     ],
        //     mode:    this.mode,
        // };
        //
        // console.log(this.status);
        // console.log(data);
        // console.log(JSON.stringify(data));
        // console.log(btoa(JSON.stringify(data)));

        const delimiter = ';';
        let parts = {race: '', subrace: '@', stats: ''};

        if ('' !== this.status.race.name) {
            parts.race = this.status.race.name;
            let code = ({ 'point-buy': 'b', 'roll': 'r', 'standard': 's'})[this.mode];
            parts.race = code + parts.race;
        }

        if (this.status.race.subrace || this.status.race.alloc1 || this.status.race.alloc2 || this.status.race.alloc3) {
            parts.subrace = `${this.status.race.subrace}${delimiter}${this.status.race.alloc1}${delimiter}${this.status.race.alloc2}${delimiter}${this.status.race.alloc3}`;
        }

        let stats = [this.status.stats.STR, this.status.stats.DEX, this.status.stats.CON, this.status.stats.INT, this.status.stats.WIS, this.status.stats.CHA, this.status.stats.HON, this.status.stats.SAN];
        if (stats.filter(stat => !!stat).length) {
            parts.stats = stats.map(val => val.toString(36)).join('');
        }

        if ('' === parts.race && '@' === parts.subrace && '' === parts.stats) {
            return;
        }

        let path = `${parts.race}`;
        if ('@' !== parts.subrace) {
            path += `${delimiter}${parts.subrace}`;
        }
        if ('' !== parts.stats) {
            if ('@' === parts.subrace) {
                path += `${delimiter}@`;
            }
            path += `${delimiter}${parts.stats}`;
        }

        window.location.hash = path;
    };

    static loadHash(hash) {
        let data = hash.replace(/^#/, '').split(';');
        if (!data.length || data[0] === '') {
            return;
        }

        let race = data[0].split('');
        let mode = race.splice(0, 1)[0];
        this.changeMode( ({ 'b':'point-buy', 'r':'roll', 's':'standard'})[mode], true );

        PointBuyCalc.status.race.name = race.join('');
        this.updateRace();

        let idx = 1;
        if (idx in data) {
            if ('@' !== data[idx]) {
                PointBuyCalc.status.race.subrace = data[idx++];
                PointBuyCalc.status.race.alloc1 = data[idx++];
                PointBuyCalc.status.race.alloc2 = data[idx++];
                PointBuyCalc.status.race.alloc3 = data[idx++];
            } else {
                ++idx;
            }
        }
        PointBuyCalc.updateSubrace();

        // console.log(data[idx]);
        if (idx in data) {
            if ('' !== data[idx]) {
                let values = data[idx].split('').map(encoded => parseInt(encoded, 36));
                this.stats.forEach((stat, index) => {
                    this.status.stats[stat] = values[index];
                });
            } else {
                ++idx;
            }
        }
        PointBuyCalc.updateStats();
    }

    static changeMode(method, dontUpdate) {
        // console.log(method);
        dontUpdate = dontUpdate || false;
        const pager = document.querySelector('.calc_pager');
        this.mode = method;
        this.withTunes = ('point-buy' === method);
        this.withRolls = ('roll' === method);
        this.standardArray = ('standard' === method);

        let methodButtons = pager.querySelectorAll('.method_button');
        for (let button of methodButtons) {
            let target = button.getAttribute('data-target');
            button.classList.toggle('btn-green', method === target);
            document.querySelector('#calc_main').classList.toggle(target, method === target);
        }

        document.querySelectorAll('.calc__stat-tune__tune-up')
            .forEach((upTune) => upTune.innerHTML = this.withTunes ? '+' : '&gt;');
        document.querySelectorAll('.calc__stat-tune__tune-down')
            .forEach((downTune) => downTune.innerHTML = this.withTunes ? '-' : '&lt;');

        document.querySelector('.calc_reset').classList.toggle('hidden', !this.withTunes);

        const statRef = this.getStats();
        // point-buy
        let newStats = [0, 0, 0, 0, 0, 0, 0, 0];
        if (this.withRolls) { // roll
            newStats = newStats.map(() => this.roll4d6dl1());
        }
        if (this.standardArray) { //standard array
            newStats = [15, 14, 13, 12, 10, 8, 11, 11];
        }

        statRef.forEach((stat, index) => { this.status.stats[stat] = newStats[index]; });

        if (!dontUpdate) {
            this.updateHash();
            this.updateStats();
        }
    }

    static roll4d6dl1()  {
        return (new Dice(6, 4))           // 4d6
            .roll()
            .values                                // rolled
            .sort()                                // sort asc
            .reverse()                             // desc
            .slice(0, 3)                           // drop 1 lowest
            .reduce((sum, roll) => sum + roll, 0); // sum
    }
}

window.addEventListener('load', () => {
    // console.log('loaded');
    PointBuyCalc.data.races = {
        "multiverse": {
            "source": "MPMM", "rname": "Multiverse", "ename": "", "classes": "", "key": "multiverse",
            stats: [],
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}]
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}]
                },
            },
        },
        "aarakocra": {
            "source": "POA", "rname": "Ааракокра", "ename": "Aarakocra", "classes": "aarakocra", "key": "aarakocra",
            stats: [{bonus: 2, stat: 'DEX'}, {bonus: 1, stat: 'WIS'}],
        },
        "aasimar": {
            "source": "VGM", "rname": "Аасимар ", "ename": "Aasimar", "classes": "aasimar", "key": "aasimar",
            stats: [{bonus: 2, stat: 'CHA'}],
            subraces: {
                protector: {key: 'protector', ename: 'Protector', rname: 'Защитник', stats: [{bonus: 1, stat: 'WIS'}]},
                scourge: {key: 'scourge', ename: 'Scourge', rname: 'Каратель', stats: [{bonus: 1, stat: 'CON'}]},
                fallen: {key: 'fallen', ename: 'Fallen', rname: 'Падший', stats: [{bonus: 1, stat: 'STR'}]},
            }
        },
        "autognome": {
            "source": "SAS", "rname": "Автогном", "ename": "Autognome", "classes": "autognome", "key": "autognome",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "bugbear": {
            "source": "VGM", "rname": "Багбир", "ename": "Bugbear", "classes": "bugbear", "key": "bugbear",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'DEX'}],
        },
        "hexblood": {
            "source": "VRGR", "rname": "Ведьмокровный", "ename": "Hexblood", "classes": "", "key": "hexblood",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "vedalken": {
            "source": "GGR", "rname": "Ведалкен", "ename": "Vedalken", "classes": "vedalken", "key": "vedalken",
            stats: [{bonus: 2, stat: 'INT'}, {bonus: 1, stat: 'WIS'}],
        },
        "verdan": {
            "source": "AI", "rname": "Вердан", "ename": "Verdan", "classes": "verdan", "key": "verdan",
            stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'CON'}],
        },
        "reborn": {
            "source": "VRGR", "rname": "Возрождённый", "ename": "Reborn", "classes": "", "key": "reborn",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "simic-hybrid": {
            "source": "GGR",
            "rname": "Гибрид Симиков",
            "ename": "Simic hybrid",
            "classes": "simic_hybrid",
            "key": "simic-hybrid",
            stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'ANY'}],
        },
        "gith": {
            "source": "MTF", "rname": "Гит", "ename": "Gith", "classes": "gith", "key": "gith",
            stats: [{bonus: 1, stat: 'INT'}],
            subraces: {
                gitzerai: {key: 'gitzerai', ename: 'Gitzerai', rname: 'Гитцераи', stats: [{bonus: 2, stat: 'WIS'}]},
                githyanki: {key: 'githyanki', ename: 'Githyanki', rname: 'Гитъянки', stats: [{bonus: 2, stat: 'STR'}]},
            }
        },
        "giff": {
            "source": "SAS", "rname": "Гифф", "ename": "Giff", "classes": "giff", "key": "giff",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "gnome": {
            "source": "PH", "rname": "Гном", "ename": "Gnome", "classes": "gnome", "key": "gnome",
            stats: [{bonus: 2, stat: 'INT'}],
            subraces: {
                forest: {key: 'forest', ename: 'forest', rname: 'Лесной', stats: [{bonus: 1, stat: 'DEX'}]},
                rock: {key: 'rock', ename: 'rock', rname: 'Скальный', stats: [{bonus: 1, stat: 'CON'}]},
                svirfneblin: {
                    key: 'svirfneblin',
                    ename: 'svirfneblin',
                    rname: 'Свирфнеблин',
                    stats: [{bonus: 1, stat: 'DEX'}]
                },
                scribing: {
                    key: 'scribing',
                    ename: 'Mark of Scribing',
                    rname: 'Метка письма',
                    stats: [{bonus: 1, stat: 'CHA'}],
                    source: 'RLW'
                },
            }
        },
        "goblin": {
            "source": "VGM", "rname": "Гоблин", "ename": "Goblin", "classes": "goblin", "key": "goblin",
            stats: [{bonus: 2, stat: 'DEX'}],
            subraces: {
                standard: {key: 'standard', ename: 'Standard', rname: 'Обычный', stats: [{bonus: 1, stat: 'CON'}]},
                dankwood: {
                    key: 'dankwood',
                    ename: 'Dankwood',
                    rname: 'Данквудский',
                    stats: [{bonus: 1, stat: 'WIS'}],
                    source: 'AWM'
                },
            }
        },
        "goliath": {
            "source": "VGM", "rname": "Голиаф", "ename": "Goliath", "classes": "goliath", "key": "goliath",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'CON'}]
        },
        "grung": {
            "source": "OGA", "rname": "Грунг ", "ename": "Grung", "classes": "grung", "key": "grung",
            stats: [{bonus: 2, stat: 'DEX'}, {bonus: 1, stat: 'CON'}],
        },
        "dhampir": {
            "source": "VRGR", "rname": "Дампир", "ename": "Dhampir", "classes": "", "key": "dhampir",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "dwarf": {
            "source": "PH", "rname": "Дварф", "ename": "Dwarf", "classes": "dwarf", "key": "dwarf",
            stats: [{bonus: 2, stat: 'CON'}],
            subraces: {
                mountain: {key: 'mountain', ename: 'Mountain', rname: 'Горный', stats: [{bonus: 2, stat: 'STR'}]},
                hill: {key: 'hill', ename: 'Hill', rname: 'Холмовой', stats: [{bonus: 1, stat: 'WIS'}]},
                duergar: {
                    key: 'duergar',
                    ename: 'Duergar',
                    rname: 'Дуэргар',
                    stats: [{bonus: 1, stat: 'STR'}],
                    source: 'MTF'
                },
                warding: {
                    key: 'warding',
                    ename: 'Mark of Warding',
                    rname: 'Метка опеки',
                    stats: [{bonus: 1, stat: 'INT'}],
                    source: 'RLW'
                },
            }
        },
        "genasi": {
            "source": "POA", "rname": "Дженази", "ename": "Genasi", "classes": "genasi", "key": "genasi",
            stats: [{bonus: 2, stat: 'CON'}],
            subraces: {
                air: {key: 'air', ename: 'Air', rname: 'Воздуха', stats: [{bonus: 1, stat: 'DEX'}]},
                earth: {key: 'earth', ename: 'Earth', rname: 'Земли', stats: [{bonus: 1, stat: 'STR'}]},
                fire: {key: 'fire', ename: 'Fire', rname: 'Огня', stats: [{bonus: 1, stat: 'INT'}]},
                water: {key: 'water', ename: 'Water', rname: 'Воды', stats: [{bonus: 1, stat: 'WIS'}]},
            }
        },
        "dragonborn": {
            "source": "PH",
            "rname": "Драконорождённый",
            "ename": "Dragonborn",
            "classes": "dragonborn",
            "key": "dragonborn",
            stats: [],
            subraces: {
                standard: {
                    key: 'standard',
                    ename: 'Standard',
                    rname: 'Обычный',
                    stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'CHA'}]
                },
                draconblood: {
                    key: 'draconblood',
                    ename: 'Draconblood',
                    rname: 'Драконокровный',
                    stats: [{bonus: 2, stat: 'INT'}, {bonus: 1, stat: 'CHA'}],
                    source: 'EGW'
                },
                ravenite: {
                    key: 'ravenite',
                    ename: 'Ravenite',
                    rname: 'Равенит',
                    stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'CON'}],
                    source: 'EGW'
                },
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                    source: 'FTD'
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                    source: 'FTD'
                },
            }
        },
        "harengon": {
            "source": "WBW", "rname": "Зайцегон", "ename": "Harengon", "classes": "", "key": "harengon",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "kalashtar": {
            "source": "RLW", "rname": "Калаштар", "ename": "Kalashtar", "classes": "kalashtar", "key": "kalashtar",
            stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'CHA'}],
        },
        "kenku": {
            "source": "VGM", "rname": "Кенку ", "ename": "Kenku", "classes": "kenku", "key": "kenku",
            stats: [{bonus: 2, stat: 'DEX'}, {bonus: 1, stat: 'WIS'}],
        },
        "centaur": {
            "source": "GGR", "rname": "Кентавр ", "ename": "Centaur", "classes": "centaur", "key": "centaur",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'WIS'}],
        },
        "kobold": {
            "source": "UA", "rname": "Кобольд", "ename": "Kobold", "classes": "kobold", "key": "kobold",
            stats: [{bonus: 2, stat: 'DEX'}],
        },
        "warforged": {
            "source": "RLW", "rname": "Кованый", "ename": "Warforged", "classes": "warforged", "key": "warforged",
            stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'ANY'}]
        },
        "leonin": {
            "source": "MOT", "rname": "Леонинец", "ename": "Leonin", "classes": "leonin", "key": "leonin",
            stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'STR'}],
        },
        "locathah": {
            "source": "LR", "rname": "Локата", "ename": "Locathah", "classes": "", "key": "locathah",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'DEX'}],
        },
        "loxodon": {
            "source": "GGR", "rname": "Локсодон", "ename": "Loxodon", "classes": "loxodon", "key": "loxodon",
            stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'WIS'}],
        },
        "lizardfolk": {
            "source": "VGM", "rname": "Людоящер", "ename": "Lizardfolk", "classes": "lizardfolk", "key": "lizardfolk",
            stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'WIS'}],
        },
        "minotaur": {
            "source": "GGR", "rname": "Минотавр", "ename": "Minotaur", "classes": "minotaur", "key": "minotaur",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'CON'}],
        },
        "orc": {
            "source": "VGM", "rname": "Орк", "ename": "Orc", "classes": "orc", "key": "orc",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'CON'}],
        },
        "plasmoid": {
            "source": "SAS", "rname": "Плазмоид", "ename": "Plasmoid", "classes": "", "key": "plasmoid",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "half-orc": {
            "source": "PH", "rname": "Полуорк", "ename": "Half-orc", "classes": "half_orc", "key": "half-orc",
            subraces: {
                standard: {
                    key: 'standard',
                    ename: 'Standard',
                    rname: 'Обычный',
                    stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'CON'}]
                },
                finding: {
                    key: 'finding',
                    ename: 'Finding',
                    rname: 'Метка поиска',
                    stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'CON'}],
                    source: 'RLW'
                },
            }
        },
        "halfling": {
            "source": "PH", "rname": "Полурослик", "ename": "Halfling", "classes": "halfling", "key": "halfling",
            stats: [{bonus: 2, stat: 'DEX'}],
            subraces: {
                stout: {key: 'stout', ename: 'Stout', rname: 'Коренастый', stats: [{bonus: 1, stat: 'CON'}]},
                lightfoot: {
                    key: 'lightfoot',
                    ename: 'Lightfoot',
                    rname: 'Легконогий',
                    stats: [{bonus: 1, stat: 'CHA'}]
                },
            }
        },
        "half-elf": {
            "source": "PH", "rname": "Полуэльф", "ename": "Half-elf", "classes": "half_elf", "key": "half-elf",
            subraces: {
                standard: {
                    key: 'standard',
                    ename: 'Standard',
                    rname: 'Обычный',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}]
                },
                detection: {
                    key: 'detection',
                    ename: 'Detection',
                    rname: 'Метка Обнаружения',
                    stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'ANY'}],
                    source: 'RLW'
                },
                storm: {
                    key: 'storm',
                    ename: 'Storm',
                    rname: 'Метка Бури',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'DEX'}],
                    source: 'RLW'
                },
            }
        },
        "satyr": {
            "source": "MOT", "rname": "Сатир", "ename": "Satyr", "classes": "satyr", "key": "satyr",
            stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'DEX'}],
        },
        "custom": {
            "source": "TCE", "rname": "Своё происхождение", "ename": "Custom lineage", "classes": "", "key": "custom",
            stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'FEAT'}]
        },
        "owlin": {
            "source": "SCC", "rname": "Совлин", "ename": "Owlin", "classes": "", "key": "owlin",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "tabaxi": {
            "source": "VGM", "rname": "Табакси", "ename": "Tabaxi", "classes": "tabaxi", "key": "tabaxi",
            stats: [{bonus: 2, stat: 'DEX'}, {bonus: 1, stat: 'CHA'}]
        },
        "tiefling": {
            "source": "PH", "rname": "Тифлинг", "ename": "Tiefling", "classes": "tiefling", "key": "tiefling",
            subraces: {
                standard: {
                    key: 'standard',
                    ename: 'Standard',
                    rname: 'Обычный',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'INT'}]
                },
                asmodeus: {
                    key: 'asmodeus',
                    ename: 'Asmodeus',
                    rname: 'Асмодей',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'INT'}],
                    source: 'MTF'
                },
                baalzebul: {
                    key: 'baalzebul',
                    ename: 'Baalzebul',
                    rname: 'Вельзевул',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'INT'}],
                    source: 'MTF'
                },
                glasya: {
                    key: 'glasya',
                    ename: 'Glasya',
                    rname: 'Гласия',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'DEX'}],
                    source: 'MTF'
                },
                dispater: {
                    key: 'dispater',
                    ename: 'Dispater',
                    rname: 'Диспатер',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'DEX'}],
                    source: 'MTF'
                },
                zariel: {
                    key: 'zariel',
                    ename: 'Zariel',
                    rname: 'Зариэль',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'STR'}],
                    source: 'MTF'
                },
                levistus: {
                    key: 'levistus',
                    ename: 'Levistus',
                    rname: 'Левистус',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'CON'}],
                    source: 'MTF'
                },
                mammon: {
                    key: 'mammon',
                    ename: 'Mammon',
                    rname: 'Маммон',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'INT'}],
                    source: 'MTF'
                },
                mephistopheles: {
                    key: 'mephistopheles',
                    ename: 'Mephistopheles',
                    rname: 'Мефистофель',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'INT'}],
                    source: 'MTF'
                },
                fierna: {
                    key: 'fierna',
                    ename: 'Fierna',
                    rname: 'Фьёрна',
                    stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'WIS'}],
                    source: 'MTF'
                },
            }
        },
        "thri-kreen": {
            "source": "SAS", "rname": "Три-крин", "ename": "Thri-kreen", "classes": "thri_kreen", "key": "thri-kreen",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "tortle": {
            "source": "TP", "rname": "Тортл", "ename": "Tortle", "classes": "", "key": "tortle",
            stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'WIS'}],
        },
        "triton": {
            "source": "VGM", "rname": "Тритон", "ename": "Triton", "classes": "triton", "key": "triton",
            stats: [{bonus: 1, stat: 'STR'}, {bonus: 1, stat: 'CON'}, {bonus: 1, stat: 'CHA'}],
        },
        "firbolg": {
            "source": "VGM", "rname": "Фирболг", "ename": "Firbolg", "classes": "firbolg", "key": "firbolg",
            stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'STR'}],
        },
        "fairy": {
            "source": "WBW", "rname": "Фейри", "ename": "Fairy", "classes": "", "key": "fairy",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "hadozee": {
            "source": "SAS", "rname": "Хадози", "ename": "Hadozee", "classes": "hadozee", "key": "hadozee",
            subraces: {
                optA: {
                    key: 'optA',
                    ename: '2 + 1',
                    rname: '2 + 1',
                    stats: [{bonus: 2, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
                optB: {
                    key: 'optB',
                    ename: '1 + 1 + 1',
                    rname: '1 + 1 + 1',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}],
                },
            }
        },
        "hobgoblin": {
            "source": "VGM", "rname": "Хобгоблин", "ename": "Hobgoblin", "classes": "hobgoblin", "key": "hobgoblin",
            stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'INT'}],
        },
        "changeling": {
            "source": "RLW", "rname": "Чейнджлинг", "ename": "Changeling", "classes": "changeling", "key": "changeling",
            stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'ANY'}],
        },
        "human": {
            "source": "PH", "rname": "Человек", "ename": "Human", "classes": "human", "key": "human",
            subraces: {
                standard: {key: 'standard', ename: 'Standard', rname: 'Обычный', stats: [{bonus: 1, stat: 'ALL'}]},
                variant: {
                    key: 'variant',
                    ename: 'Variant',
                    rname: 'Альтернативный',
                    stats: [{bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'ANY'}, {bonus: 1, stat: 'FEAT'}]
                },
                finding: {
                    key: 'finding',
                    ename: 'Finding',
                    rname: 'Метка поиска',
                    stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'CON'}],
                    source: 'RLW'
                },
                handling: {
                    key: 'handling',
                    ename: 'Handling',
                    rname: 'Метка ухода',
                    stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'ANY'}],
                    source: 'RLW'
                },
                making: {
                    key: 'making',
                    ename: 'Making',
                    rname: 'Метка создания',
                    stats: [{bonus: 2, stat: 'INT'}, {bonus: 1, stat: 'ANY'}],
                    source: 'RLW'
                },
                passage: {
                    key: 'passage',
                    ename: 'Passage',
                    rname: 'Метка прохода',
                    stats: [{bonus: 2, stat: 'DEX'}, {bonus: 1, stat: 'ANY'}],
                    source: 'RLW'
                },
                sentinel: {
                    key: 'sentinel',
                    ename: 'Sentinel',
                    rname: 'Метка стража',
                    stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'WIS'}],
                    source: 'RLW'
                },
            }
        },
        "shifter": {
            "source": "RLW", "rname": "Шифтер", "ename": "Shifter", "classes": "shifter", "key": "shifter",
            subraces: {
                beasthide: {
                    key: 'beasthide',
                    ename: 'Beasthide',
                    rname: 'Зверошкур',
                    stats: [{bonus: 2, stat: 'CON'}, {bonus: 1, stat: 'STR'}],
                },
                longtooth: {
                    key: 'longtooth',
                    ename: 'Longtooth',
                    rname: 'Длиннозуб',
                    stats: [{bonus: 2, stat: 'STR'}, {bonus: 1, stat: 'DEX'}],
                },
                swiftstride: {
                    key: 'swiftstride',
                    ename: 'Swiftstride ',
                    rname: 'Быстроног',
                    stats: [{bonus: 2, stat: 'DEX'}, {bonus: 1, stat: 'CHA'}],
                },
                wildhunt: {
                    key: 'wildhunt',
                    ename: 'Wildhunt',
                    rname: 'Дикий охотник',
                    stats: [{bonus: 2, stat: 'WIS'}, {bonus: 1, stat: 'DEX'}],
                },
            }
        },
        "elf": {
            "source": "PH", "rname": "Эльф", "ename": "Elf", "classes": "elf", "key": "elf",
            stats: [{bonus: 2, stat: 'DEX'}],
            subraces: {
                high: {key: 'high', ename: 'High', rname: 'Высший', stats: [{bonus: 1, stat: 'INT'}]},
                wood: {key: 'wood', ename: 'Wood', rname: 'Лесной', stats: [{bonus: 1, stat: 'WIS'}]},
                drow: {key: 'drow', ename: 'Dark', rname: 'Тёмный', stats: [{bonus: 1, stat: 'CHA'}]},
                eladrin: {
                    key: 'eladrin',
                    ename: 'Eladrin',
                    rname: 'Эладрин',
                    stats: [{bonus: 1, stat: 'CHA'}],
                    source: 'MTF'
                },
                sea: {key: 'sea', ename: 'Sea', rname: 'Морской', stats: [{bonus: 1, stat: 'CON'}], source: 'MTF'},
                shadarkai: {
                    key: 'shadarkai',
                    ename: 'Shadar-kai',
                    rname: 'Шадар-кай',
                    stats: [{bonus: 1, stat: 'CON'}],
                    source: 'MTF'
                },
                shadow: {
                    key: 'shadow',
                    ename: 'Mark of Shadow',
                    rname: 'Метка Тени',
                    stats: [{bonus: 1, stat: 'CHA'}],
                    source: 'RLW'
                },
                pallid: {
                    key: 'pallid',
                    ename: 'Pallid',
                    rname: 'Бледный',
                    stats: [{bonus: 1, stat: 'WIS'}],
                    source: 'EGW'
                },
            }
        },
        "yuan-ti": {
            "source": "VGM",
            "rname": "Юань-ти",
            "ename": "Yuan-ti Pureblood",
            "classes": "yuan_ti_pureblood",
            "key": "yuan-ti",
            stats: [{bonus: 2, stat: 'CHA'}, {bonus: 1, stat: 'INT'}],
        },
    };

    PointBuyCalc.init();
});